import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const TrashSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#343330",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M20.25 4.5H16.5V3.75C16.5 3.15326 16.263 2.58097 15.841 2.15901C15.4191 1.73705 14.8468 1.5 14.25 1.5H9.75003C9.15329 1.5 8.581 1.73705 8.15904 2.15901C7.73708 2.58097 7.50003 3.15326 7.50003 3.75V4.5H3.75003C3.55112 4.5 3.36035 4.57902 3.2197 4.71967C3.07905 4.86032 3.00003 5.05109 3.00003 5.25C3.00003 5.44891 3.07905 5.63968 3.2197 5.78033C3.36035 5.92098 3.55112 6 3.75003 6H4.50003V19.5C4.50003 19.8978 4.65807 20.2794 4.93937 20.5607C5.22067 20.842 5.60221 21 6.00003 21H18C18.3979 21 18.7794 20.842 19.0607 20.5607C19.342 20.2794 19.5 19.8978 19.5 19.5V6H20.25C20.4489 6 20.6397 5.92098 20.7804 5.78033C20.921 5.63968 21 5.44891 21 5.25C21 5.05109 20.921 4.86032 20.7804 4.71967C20.6397 4.57902 20.4489 4.5 20.25 4.5ZM9.00003 3.75C9.00003 3.55109 9.07905 3.36032 9.2197 3.21967C9.36035 3.07902 9.55112 3 9.75003 3H14.25C14.4489 3 14.6397 3.07902 14.7804 3.21967C14.921 3.36032 15 3.55109 15 3.75V4.5H9.00003V3.75ZM18 19.5H6.00003V6H18V19.5ZM10.5 9.75V15.75C10.5 15.9489 10.421 16.1397 10.2804 16.2803C10.1397 16.421 9.94894 16.5 9.75003 16.5C9.55112 16.5 9.36035 16.421 9.2197 16.2803C9.07905 16.1397 9.00003 15.9489 9.00003 15.75V9.75C9.00003 9.55109 9.07905 9.36032 9.2197 9.21967C9.36035 9.07902 9.55112 9 9.75003 9C9.94894 9 10.1397 9.07902 10.2804 9.21967C10.421 9.36032 10.5 9.55109 10.5 9.75ZM15 9.75V15.75C15 15.9489 14.921 16.1397 14.7804 16.2803C14.6397 16.421 14.4489 16.5 14.25 16.5C14.0511 16.5 13.8604 16.421 13.7197 16.2803C13.579 16.1397 13.5 15.9489 13.5 15.75V9.75C13.5 9.55109 13.579 9.36032 13.7197 9.21967C13.8604 9.07902 14.0511 9 14.25 9C14.4489 9 14.6397 9.07902 14.7804 9.21967C14.921 9.36032 15 9.55109 15 9.75Z"
        fill={color}
      />
    </svg>
  );
};

export { TrashSvg };
